<template lang="pug">
  section.p_scene
    .p_scene-inner#scene
      .p_scene-header._fade.fade_in.scale
        h2.p_scene-heading.c_heading1
          span.-text.c_heading1-text Scene
      .p_scene-body._fade.fade_in.scale
        slick(ref="slick", :options="slickOptions")
          .p_sc(v-for="(item, key) in 4", :key="key")
            .p_sc-image
                img(:src="getImage('/top', '/img4_' + (key + 1) + '.jpg', '')", alt="")
</template>

<script>
import Slick from '@/components/slickCarousel'
export default {
  name: 'TheScene',
  components: {
    Slick,
  },
  data () {
    return {
      slickOptions: {
        slidesToShow: 1,
        slidesToScroll: 1,
        centerMode: true,
        arrows: true,
        dots: false,
        autoplaySpeed: 5000,
        autoplay: true,
        speed: 1000,
        centerPadding: '16.666666666666664vw',
        prevArrow: '<button type="button" class="p_scene-btn-prev p_scene-btn"><i class="-arr"><span class="prev u_rotate-45-l"></i></button>',
        nextArrow: '<button type="button", class="p_scene-btn-next p_scene-btn"><i class="-arr"><span class="next u_rotate-45-r"></i></button>',
        infinite: true,
        responsive: [
          {
            // for SP
            breakpoint: 769,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
              centerMode: false,
              infinite: true,
              arrows: true,
              dots: false,
            }
          },
        ]
      },
    }
  }
}
</script>

<style lang="scss" scoped>
.p_scene {
  @include pc {
    padding: rem(110) 0 rem(40);
  }
  @include sp {
    margin: vw(-46,750) 0 0;
    padding: 0 0 rem(40);
  }

  &-inner {}

  &-header {
    @include pc {
      margin: 0 0 rem(80);
    }
    @include sp {
      margin: 0 0 rem(74,2);
    }
    text-align: center;
  }

  &-heading {
    .-text {
      @include sp {
        font-size: vw(120,750);
      }
      letter-spacing: .4em;
    }
  }

  &-body {
    position: relative;
  }
}

.p_sc {
  @include pc {
    padding: 0 rem(25);
  }

  &-image {
  }
}
</style>

<style lang="scss">
.p_scene {

  &-btn {
    top: 50%;
    transform: translateY(-50%);
    width: rem(60);
    height: rem(60);
    background: $palet1;
    display: block;
    position: absolute;
    z-index: 999;

    &:hover {
      @include pc {
        @include hover();
      }
    }

    .-arr {
      width: rem(18);
      height: rem(18);
      display: block;
      position: absolute;
      margin: auto;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
    }

    &-prev {
      left: 0;

      .prev {
        width: 100%;
        height: 100%;
        position: absolute;
        margin: auto;
        left: 0;
        top: 0;
        display: block;
        border-width: 1px 1px 0 0;
        border-style: solid;
        border-color: #fff #fff transparent transparent;
      }
    }

    &-next {
      right: 0;

      .next {
        width: 100%;
        height: 100%;
        position: absolute;
        margin: auto;
        left: 0;
        top: 0;
        display: block;
        border-width: 1px 1px 0 0;
        border-style: solid;
        border-color: #fff #fff transparent transparent;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/top/TheScene.vue